/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedORPListListResponse } from '../types/PaginatedORPListList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type OrpListRequest = {} | null | undefined;
export type OrpListResponse = PaginatedORPListListResponse;

export type OrpListQuery = {
  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;
};

/**
 * GET /dmx-server/orp/
 *
 * ```yaml
 * operationId: orp_list
 * tags:
 *   - orp
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedORPListList'
 *     description: ''
 * ```
 */
export const orpListOperation = (rest?: OrpListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/orp/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/orp/' };
  };

/**
 * GET /dmx-server/orp/
 *
 * ```yaml
 * operationId: orp_list
 * tags:
 *   - orp
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedORPListList'
 *     description: ''
 * ```
 */
export const orpList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: OrpListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedORPListListResponse>> => {
  const operation = orpListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/orp/
 */
export const useOrpListResource = (
  query: OrpListQuery | null,
  useCached?: boolean,
): UseResource<OrpListResponse> => {
  return useResource<OrpListResponse>({
    path: query === null ? null : orpListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
